"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRODUCTION_DOMAIN () {
        return PRODUCTION_DOMAIN;
    },
    get ROOT_SERVICE () {
        return ROOT_SERVICE;
    },
    get allowedOriginsForDomainConfig () {
        return allowedOriginsForDomainConfig;
    },
    get buildDomain () {
        return buildDomain;
    },
    get domainConfigForEnvironmentStage () {
        return domainConfigForEnvironmentStage;
    },
    get domainConfigFromEnv () {
        return domainConfigFromEnv;
    },
    get resolveDomainConfig () {
        return resolveDomainConfig;
    }
});
const ROOT_SERVICE = "ROOT";
const PRODUCTION_DOMAIN = {
    base: "talent.performyard.com",
    envSegment: null
};
const buildDomain = (config, service)=>{
    const serviceLabel = service && service !== ROOT_SERVICE ? service : null;
    const { base, envSegment } = config;
    return [
        serviceLabel,
        envSegment,
        base
    ].filter(Boolean).join(".");
};
const escapeForRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const allowedOriginsForDomainConfig = (config)=>{
    const base = escapeForRegExp(config.base);
    const labelStart = "(?:^|//|\\.)";
    if (!config.envSegment) {
        return [
            new RegExp(`${labelStart}${base}$`)
        ];
    }
    const segment = escapeForRegExp(config.envSegment);
    return [
        new RegExp(`${labelStart}${segment}\\.${base}$`)
    ];
};
const ambientEnv = ()=>typeof process === "undefined" ? {} : process.env;
const domainConfigFromEnv = (env = ambientEnv())=>{
    const base = env.PY_DOMAIN_BASE?.trim();
    if (!base) {
        return null;
    }
    return {
        base,
        envSegment: env.PY_DOMAIN_ENV_SEGMENT?.trim() || null
    };
};
const domainConfigForEnvironmentStage = (environmentStage, options = {})=>{
    const { useDevEnvNames = true } = options;
    const nestedDomainConfig = (base, envSegment)=>({
            base,
            envSegment
        });
    // Bare "dev" is the local value; deployed environments always carry a full
    // environment name such as "dev-luke".
    if (!environmentStage || environmentStage === "other" || environmentStage === "dev") {
        return nestedDomainConfig("staging.talent.performyard.com", null);
    }
    if (environmentStage === "local" || environmentStage === "localhost") {
        return null;
    }
    if (environmentStage.startsWith("dev-")) {
        return useDevEnvNames ? nestedDomainConfig("staging.performyard.com", environmentStage.slice("dev-".length)) : nestedDomainConfig("staging.talent.performyard.com", null);
    }
    if (environmentStage === "production") {
        return nestedDomainConfig("talent.performyard.com", null);
    }
    if ([
        "staging",
        "sandbox",
        "demo",
        "preview"
    ].includes(environmentStage)) {
        return nestedDomainConfig("talent.performyard.com", environmentStage);
    }
    return nestedDomainConfig("staging.performyard.com", environmentStage);
};
const resolveDomainConfig = (environmentStage, options = {})=>{
    const { useDevEnvNames, env } = options;
    return domainConfigFromEnv(env ?? ambientEnv()) ?? domainConfigForEnvironmentStage(environmentStage, {
        useDevEnvNames
    });
};
